import * as React from 'react';
import {Component} from 'react';
import {observer} from 'mobx-react';
import {textConst, texts, getLocalizedText} from '../../../../constants/TextConst';
import {createNewContainer} from '../actions/Screen';
import {Button} from '../../../../components/Common/Buttons/Button';
import List from '../../../../components/Common/List';
import GeneratorPanel from './GeneratorPanel';
import ContainerField from './ContainerField';
import checkMark from '../../../../images/check_mark.png';
import NewContainerInput from '../../TemplateReport/components/NewContainerInput';

type BottomProp = {
    closePanel: () => void;
};

export const Bottom: React.FC<BottomProp> = ({closePanel}) => {
    return (
        <div className="panel-bottom">
            <Button
                componentClasses="confirm-btn"
                onClick={closePanel}
                img={checkMark}
                alt={textConst.confirmAlt}
                text={getLocalizedText(texts.save)}
                labeled
                roundCorners
            />
        </div>
    );
};

@observer
export default class Container extends Component<any, any> {
    constructor(props) {
        super(props);

        this.newContainer = this.newContainer.bind(this);
        this.renderItem = this.renderItem.bind(this);
    }

    newContainer(title) {
        createNewContainer(this.props.screensStore.selectedScreen, title);
    }

    renderItem({item}) {
        return <ContainerField field={item} />;
    }

    renderList() {
        const {screen} = this.props;
        return (
            <div className="list long">
                <div className="line" />
                <List data={screen.collection.fields} renderItem={this.renderItem} />
            </div>
        );
    }

    renderInput() {
        const {screen} = this.props;
        return (
            <div className="add-new-container">
                {/*TODO: use the generic buttons*/}
                <NewContainerInput
                    style="new-field-container"
                    designScreen={screen}
                    placeholder={getLocalizedText(texts.newContainerPlaceholderText)}
                    btntext={getLocalizedText(texts.newContainerBtnText)}
                    onClick={this.newContainer}
                />
            </div>
        );
    }

    renderGeneratorPanel() {
        // TODO: check what are the texts props
        const {screen} = this.props;
        const isOpen = screen.selected && screen.selected.hasContainerData;

        return <GeneratorPanel designScreen={screen} texts={this.props.texts} open={isOpen} />;
    }

    render() {
        const {selected} = this.props.screen;
        const isGeneratorOpen = selected && selected.hasContainerData;

        return (
            <div className="screen">
                <div className="content-wrapper wide">
                    <div
                        className={
                            'content container' +
                            (selected && selected.hasContainerData ? ' edit-container' : '')
                        }
                    >
                        {this.renderList()}
                        {this.renderInput()}
                    </div>
                    {this.renderGeneratorPanel()}
                </div>
                {!isGeneratorOpen && <Bottom {...(this.props as BottomProp)} />}
            </div>
        );
    }
}
